var SelectedApplicationService_1;
import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { SessionStorageService } from "../storage/session-storage.service";
import { SessionStorageEnum } from "../storage/session-storage-constants";
import { AflaModuleStrategyService } from "../afla-module-strategy/afla-module-strategy.service";
import { HttpClient } from "@angular/common/http";
import { map } from "rxjs/operators";
export let SelectedApplicationService = class SelectedApplicationService {
    static { SelectedApplicationService_1 = this; }
    sessionStorageService;
    http;
    $applicationSavedSubject = new BehaviorSubject(false);
    childRefreshedSubject = new BehaviorSubject({ applicationRefreshed: false, refreshUrl: "" });
    clearDeceasedNamesTableSubject$ = new BehaviorSubject(false);
    selectedApplicationSubject = new BehaviorSubject(null);
    $selectedApplication = this.selectedApplicationSubject.asObservable();
    incompleteJobId = new BehaviorSubject(0);
    $incompleteJobId = this.incompleteJobId.asObservable();
    startNewApplication = new BehaviorSubject(false);
    $startNewApplication = this.startNewApplication.asObservable();
    constructor(sessionStorageService, http) {
        this.sessionStorageService = sessionStorageService;
        this.http = http;
    }
    static buildGetSingleRequest(aflaModuleStrategyService, jobId, expandList) {
        const params = {
            $expand: expandList, $filter: AflaModuleStrategyService.buildJobIDFilter(jobId)
        };
        return aflaModuleStrategyService.getApplicationsQuery(params);
    }
    static getExpandList(aflaModuleStrategyService) {
        return aflaModuleStrategyService.expandListForApplicationPartial;
    }
    setStartNewApplication(start) {
        this.startNewApplication.next(start);
    }
    setIncompleteJobId(jobId) {
        this.incompleteJobId.next(jobId);
    }
    setSelectedApplication(application) {
        this.selectedApplicationSubject.next(application);
        if (!application) {
            return;
        }
        this.sessionStorageService.set(SessionStorageEnum.SelectedJobID, application.jobId.toString());
    }
    fetchSelectedApplicationFromJobID(jobID, aflaModuleStrategyService) {
        this.getSingleApplication(aflaModuleStrategyService, jobID).subscribe({
            next: (selectedApplication) => {
                this.setSelectedApplication(selectedApplication);
                this.$applicationSavedSubject.next(true);
            }
        });
    }
    getSingleApplication(aflaModuleStrategyService, jobId) {
        return SelectedApplicationService_1.buildGetSingleRequest(aflaModuleStrategyService, jobId, SelectedApplicationService_1.getExpandList(aflaModuleStrategyService))
            .pipe(map((applicationList) => {
            return applicationList.value.map((application) => {
                return application;
            })?.pop();
        }));
    }
    getSelectedApplicationGeometry(url, params) {
        return this.http.get(url, { params });
    }
    static ctorParameters = () => [
        { type: SessionStorageService },
        { type: HttpClient }
    ];
};
SelectedApplicationService = SelectedApplicationService_1 = __decorate([
    Injectable({
        providedIn: "root"
    })
], SelectedApplicationService);
